<template>
    <div class="progress-bar-wrap">
        <button
            class="progress-nav-btn progress-nav-prev"
            @click="$emit('prev')"
            :aria-label="currentStep === 0 ? 'Exit' : 'Previous step'"
        >
            <ChevronLeft style="width:20px;height:20px" />
            <span v-if="currentStep === 0" class="progress-nav-exit-label">Exit</span>
        </button>

        <div class="progress-bar-content">
            <div class="progress-bar-track">
                <div
                    v-for="(_, i) in totalSteps"
                    :key="i"
                    class="progress-bar-segment"
                    :style="{ flex: STEP_WEIGHTS[i] }"
                >
                    <div
                        class="progress-bar-fill"
                        :style="{ width: i <= currentStep ? '100%' : '0%' }"
                    />
                </div>
            </div>
            <div class="progress-bar-label">
                Step {{ currentStep + 1 }}<span class="progress-bar-step-name"> · {{ STEP_NAMES[currentStep] }}</span>
            </div>
        </div>

        <button
            v-if="currentStep < totalSteps - 1"
            class="progress-nav-btn progress-nav-next"
            :class="{ 'is-disabled': !canAdvance }"
            :disabled="!canAdvance"
            @click="$emit('next')"
            aria-label="Next step"
        >
            <ChevronRight style="width:20px;height:20px" />
        </button>
    </div>
</template>

<script setup>
import { ChevronLeft, ChevronRight } from 'lucide-vue-next'

defineProps({
    currentStep:  { type: Number, required: true },
    totalSteps:   { type: Number, default: 6 },
    canAdvance:   { type: Boolean, default: false },
})

defineEmits(['prev', 'next'])

const STEP_NAMES   = ['Cast', 'Format', 'Setting', 'Title', 'Synopsis', 'Launch']
const STEP_WEIGHTS = [3, 1, 2, 2, 4, 1]
</script>

<style scoped>
.progress-bar-wrap    { padding: 12px 16px; display: flex; align-items: center; gap: 8px; }
.progress-bar-content { flex: 1; min-width: 0; }
.progress-bar-track   { display: flex; gap: 6px; margin-bottom: 8px; }
.progress-bar-segment { height: 3px; background: rgba(255,255,255,0.1); border-radius: 2px; overflow: hidden; }
.progress-bar-fill    { height: 100%; background: white; transition: width 0.4s ease; }
.progress-bar-label   { font-size: 14px; color: rgba(255,255,255,0.5); font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.progress-bar-step-name { color: #c4b5fd; font-weight: 600; }
.progress-nav-btn     { background: none; border: none; color: rgba(255,255,255,0.6); cursor: pointer; padding: 4px; border-radius: 6px; display: flex; align-items: center; justify-content: center; transition: all 0.2s; flex-shrink: 0; }
.progress-nav-btn:hover { background: rgba(255,255,255,0.1); color: white; }
.progress-nav-btn:active { transform: scale(0.95); }
.progress-nav-btn.is-disabled { opacity: 0.25; cursor: not-allowed; pointer-events: none; }
.progress-nav-exit-label { font-size: 13px; font-weight: 500; color: inherit; }

@media (max-width: 360px) {
    .progress-bar-wrap { padding: 12px 12px; gap: 6px; }
    .progress-bar-label { font-size: 13px; }
    .progress-bar-step-name { display: none; }
}
</style>
